module.exports = __webpack_public_path__ + "static/media/webix.a2ea4f74.svg";